import { getSessionAuthentication, rms2BasePath } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface Currency {
    id: number;
    code: string;
    name: string;
    number: string;
    currencyRate: number;
}

export async function getCurrency(currencyId: number): Promise<Currency> {
    return rms2Fetch<Currency>(`currencies/${currencyId}`);
}

export async function saveCurrency(currency: Partial<Currency>): Promise<Currency> {
    return rms2Fetch<Currency>('currencies', {
        method: 'POST',
        body: JSON.stringify(currency),
    });
}

export async function updateCurrency(currency: Currency): Promise<Currency> {
    return rms2Fetch<Currency>('currencies', {
        method: 'PUT',
        body: JSON.stringify(currency),
    });
}

export async function deleteCurrency(currencyId: number): Promise<void> {
    await rms2Fetch<void>(`currencies/${currencyId}`, {
        method: 'DELETE',
    });
}
